import React from "react";
import { Snackbar, Alert } from "@mui/material";

const FormManagementPopup = ({
  open,
  severity = "info",
  message = "",
  onClose,
  autoHideDuration = 3000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ zIndex: 10000, mt: "3rem" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ width: "100%", minWidth: { xs: 280, sm: 420 }, color: "#fff" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default FormManagementPopup;
